import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Printer } from "lucide-react";

export const DeviceBarcodeLabel = ({ device, onClose }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!device) return;
    const t = setTimeout(() => {
      if (svgRef.current) {
        try {
          JsBarcode(svgRef.current, device.biomed_no, {
            format: "CODE128",
            displayValue: false,
            height: 42,
            width: 1.6,
            margin: 0,
          });
        } catch (e) {
          console.error("Barcode render failed", e);
        }
      }
    }, 100);
    return () => clearTimeout(t);
  }, [device]);

  if (!device) return null;

  return (
    <Dialog open={!!device} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl" className="max-w-sm">
        <DialogHeader>
          <DialogTitle>ملصق باركود الجهاز</DialogTitle>
          <DialogDescription>حجم الطباعة: 6 × 4 سم</DialogDescription>
        </DialogHeader>

        <style>{`
          .device-label {
            width: 60mm;
            height: 40mm;
            border: 1px solid #E5E7EB;
            border-radius: 4px;
            background: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding: 4mm 3mm 2.5mm;
            direction: ltr;
            overflow: hidden;
          }
          .device-label .lbl-head {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.8mm;
            width: 100%;
            justify-content: center;
          }
          .device-label .lbl-head img { height: 6mm; filter: brightness(0); }
          .device-label .lbl-head .brand {
            font-size: 7pt;
            font-weight: 700;
            color: #0A0A0A;
            letter-spacing: 0.4px;
            line-height: 1;
            text-align: center;
          }
          .device-label .lbl-name {
            font-size: 6.5pt;
            color: #0A0A0A;
            font-weight: 600;
            max-width: 54mm;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
          }
          .device-label svg { max-width: 54mm; }
          .device-label .lbl-no {
            font-family: 'Courier New', monospace;
            font-size: 9pt;
            font-weight: 700;
            letter-spacing: 1.5px;
            color: #0A0A0A;
          }
          .device-label .lbl-serial {
            font-family: 'Courier New', monospace;
            font-size: 6.5pt;
            font-weight: 600;
            letter-spacing: 0.5px;
            color: #0A0A0A;
            max-width: 54mm;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1;
          }
          @media print {
            @page { size: 60mm 40mm; margin: 0; }
            /* Remove the app root from layout flow entirely so only ONE label page prints */
            #root { display: none !important; }
            html, body {
              width: 60mm !important;
              height: 40mm !important;
              max-height: 40mm !important;
              overflow: hidden !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            body * { visibility: hidden !important; }
            .device-label, .device-label * { visibility: visible !important; }
            .device-label {
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              border: none !important;
              border-radius: 0 !important;
              margin: 0 !important;
            }
          }
        `}</style>

        <div className="flex justify-center py-2">
          <div className="device-label" data-testid="device-barcode-label">
            <div className="lbl-head">
              <img src="/lucent-logo.png" alt="Lucent" />
              <div className="brand">Lucent Dental Center Co.,</div>
            </div>
            <div className="lbl-name">{device.device_name}</div>
            <svg ref={svgRef}></svg>
            <div className="lbl-no">{device.biomed_no}</div>
            {(device.device_type === "electrical" || device.device_type === "electric") && device.serial_no && (
              <div className="lbl-serial" data-testid="label-serial">SN: {device.serial_no}</div>
            )}
          </div>
        </div>

        <Button onClick={() => window.print()} className="w-full bg-[#655dc6] hover:bg-[#5449a8] text-white gap-2" data-testid="print-barcode-btn">
          <Printer className="w-4 h-4" /> طباعة الملصق
        </Button>
      </DialogContent>
    </Dialog>
  );
};
